import Complaints from './Complaints';

export default Complaints;
